//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface AbsenceAutoTimeEntry {
  id: number;
  idPerson: number;
  startDate: string;
  endDate: string;
  station: string | undefined;
}

export interface AbsenceAutoTimeEntryAdmin extends AbsenceAutoTimeEntry {
  idChronoUser: number;
}

export interface AbsenceConfirmationItem {
  person: string | undefined;
  idPerson: number;
  idAdmiaUser: number;
  accepted: boolean;
  kontoName: string | undefined;
  email: string | undefined;
  text: string | undefined;
  emailSuperior: string | undefined;
  textSuperior: string | undefined;
  emailResponse: string | undefined;
  from: string;
  to: string;
  absences: RequestedAbsencesListItem[] | undefined;

  idAbsence: number;
  aktuell?: string;
  angefragt?: string;
  prognose?: string;
  prognosePositive?: boolean;

  overdraft?: {
    currentHours: number;
    requestedHours: number;
    projectedHours: number;

    currentLabel: string;
    requestedLabel: string;
    projectedLabel: string;

    positive: boolean;
  };
}

export interface AbsenceListItem {
  id: number;
  absenceNr: string | undefined;
  name: string | undefined;
  color: string | undefined;
  colorCode: number;
}

export interface AbsencePlanerUserList {
  id: number;
  idPerson: number;
  idAdminUser: number;
  edit: boolean;
  personalNR: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
  groupingName: string | undefined;
}

export interface AbsencePlanerUserParameter {
  chronoUserID: number;
  personalID: number;
  grouping: number;
  filter: number;
  filterID: number;
  showFuture?: boolean;
}

export interface Account {
  name: string | undefined;
  konto: string | undefined;
  saldo: number;
  saldoInDays: number;
  hourPerDay: number;
  saldoVisible: boolean;
  saldoInDaysVisible: boolean;
}

export interface AccountModel {
  id: number;
  konto: string | undefined;
  name: string | undefined;
  description: string | undefined;
  color: string | undefined;
  short: string | undefined;
  payed: boolean;
  addToVorholzeit: boolean;
  usePercentage: boolean;
  percentageOfDailyWorkTimeMax: number;
  percentageOfDailyWorkTimeMin: number;
  hoursPerDayMin: number;
  hoursPerDayMax: number;
  isAbsence: boolean;
  chargedAccountID: number;
}

export interface DefaultWorkModel {
  id: number;
  active: boolean;
  person: PersonalApiModel;
  order: OrderModel;
  costCenter: CostCenterModel;
  operation: OperationModel;
  orderSelection: boolean;
  costCenterSelection: boolean;
  allowOnlyPreCalculatedCostCenter: boolean;
  allowOnlyPreCalculatedOperations: boolean;
  hasPassword: boolean;
  inCompany: boolean;
}

export interface AdminPersonalBatchModel extends DefaultWorkModel {
  batchMutationResult: string | undefined;
}

export interface AdminPersonalBatchModelPagedResult {
  items: AdminPersonalBatchModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface AdminPersonalBatchModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: AdminPersonalBatchModelPagedResult;
}

export interface HolidayOverdraftCheckResponse {
  willBeNegative: boolean;

  requestedHolidayHours?: number | null;
  projectedHolidayHours?: number | null;
  currentHolidayHours?: number | null;

  requestedHolidayDays?: number | null;
  projectedHolidayDays?: number | null;
  currentHolidayDays?: number | null;
}

export interface AuthenticationModel {
  successful: boolean;
  user: WebAppUser;
  error: LoginErrorResponse;
  chronoVersion: ChronoVersionEnum;
}

export interface AuthenticationRequest {
  controllerId: string | undefined;
  secret: string | undefined;
}

export interface AuthenticationResponse {
  culture: string | undefined;
  token: string | undefined;
}

export interface AuthenticationResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: AuthenticationResponse;
}

export interface AutoGoModel {
  id: number;
  name: string | undefined;
  goEqualCome: boolean;
  goAfterTime: boolean;
  userDefinedGo: boolean;
  goTime: string;
}

export interface BadgeAbsenceRequest {
  personID: number;
  absenceID: number;
}

export interface BadgeComeAndGo {
  isWorking: boolean;
  security: Security;
}

export interface BadgeDayInfo {
  text: string | undefined;
  currentTimeEntry: TimeEntrySimple;
  security: Security;
}

export interface BadgeResponse {
  workInfo: WorkInfo;
  comeAndGo: BadgeComeAndGo;
  dayInfo: BadgeDayInfo;
  warnings: string | undefined;
  eMailMessage: string | undefined;
}

export interface BalanceBookingModel {
  id: number;
  person: PersonalApiModel;
  date: string;
  time: number;
  text: string | undefined;
  fromAccountText: string | undefined;
  toAccountText: string | undefined;
  auto: boolean;
  fromAccount: AccountModel;
  toAccount: AccountModel;
  type: number;
  userName: string | undefined;
  visum: number;
  changeDate: string;
}

export interface BalanceBookingModelPagedResult {
  items: BalanceBookingModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface BalanceBookingModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: BalanceBookingModelPagedResult;
}

export interface PagedQuery {
  pageNumber: number;
  pageSize: number;
  filterFullText: boolean;
  full: boolean;
  sortBy: string | undefined;
  sortOrder: string | undefined;
  authorisation: boolean;
  includeNullPerson: boolean;
  authorizedPerson: number[] | undefined;
  pageDistinct: boolean;
  pageDistinctField: string | undefined;
}

export interface BalanceBookingQuery extends PagedQuery {
  id: number | undefined;
  personID: number | undefined;
  personNumber: string | undefined;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  time: number | undefined;
  text: string | undefined;
  fromAccountID: number | undefined;
  fromAccountKonto: string | undefined;
  fromAccountName: string | undefined;
  fromAccountText: string | undefined;
  toAccountID: number | undefined;
  toAccountKonto: string | undefined;
  toAccountName: string | undefined;
  toAccountText: string | undefined;
  type: number | undefined;
  userName: string | undefined;
  visum: number | undefined;
  auto: boolean | undefined;
  changeDateFrom: string | undefined;
  changeDateTo: string | undefined;
}

export interface BarcodeParameter {
  barcode: string | undefined;
  idPerson: number;
}

export interface Base64Attachment {
  name: string | undefined;
  base64Data: string | undefined;
}

export interface BaseGroupModel {
  id: number;
  name: string | undefined;
  addition: string | undefined;
}

export interface BaseItemModel {
  id: number;
}

export interface BaseOrderPersonItem {
  person: PersonalApiModel;
  order: OrderModel;
  date: string;
  authorisation: ItemAuthorisation;
}

export interface BlockSettingsModel {
  from: string;
  to: string;
  reduction: number;
}

export interface BlockTimeModel {
  id: number;
  name: string | undefined;
  block1: BlockSettingsModel;
  block2: BlockSettingsModel;
}

export interface BranchModel extends BaseItemModel {
  branch: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  idMainBranch: number;
}

export interface BranchModelPagedResult {
  items: BranchModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface BranchModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: BranchModelPagedResult;
}

export interface BranchModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: BranchModel;
}

export interface BranchModelTimelinePeriodicModel {
  personal: PersonDataModel[] | undefined;
  start: string;
  end: string;
  period: TimelinePeriod;
  periodLenght: number;
  items: BranchModel[] | undefined;
}

export interface BranchModelTimelinePeriodicModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: BranchModelTimelinePeriodicModel;
}

export interface BranchQuery extends PagedQuery {
  id: number | undefined;
  branch: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
}

export interface BreakModel {
  id: number;
  name: string | undefined;
  break1: BreakSetting;
  break2: BreakSetting;
  break3: BreakSetting;
  break4: BreakSetting;
  calcualteInMaintencanceRun: boolean;
}

export interface BreakSetting {
  from: string;
  to: string;
  discountMinutes: number;
}

export interface CalendarItem {
  id: number;
  datum: string;
  konto: string | undefined;
  colorName: string | undefined;
  color: number;
  isFeiertag: boolean;
  isRequestedOnly: boolean;
  isWorkItem: boolean;
  personID: number;
  filled: number;
  resourceID: number;
}

export interface CalendarPlanerParamters {
  range: DateRange;
  users: AbsencePlanerUserList[] | undefined;
}

export interface CalendarWorkItemCount {
  id: number;
  date: string;
  count: number;
}

export interface NewTimeEntry {
  personID: number;
  absenceID: number;
  orderID: number;
  costCenterID: number;
  admiaUserID: number;
  dateStart: string;
  dateEnd: string;
  startTime: string;
  endTime: string;
  hours: number;
  operation: string | undefined;
  station: string | undefined;
  note: NoteListItem;
}

export interface ChangedTimeEntry extends NewTimeEntry {
  startTimeEntryID: number;
  endTimeEntryID: number;
  modUserName: string | undefined;
}

export interface ChronoUserAuth {
  successful: boolean;
  user: UserModel;
  token: string | undefined;
  message: string | undefined;
}

export interface ChronoUserLoginParamter {
  chronoUserID: number;
  internalAdmin: boolean;
  password: string | undefined;
}

export interface ChronoUserModel {
  idAdmiaUser: number;
  idPerson: number;
  idAbteilung: number;
  name: string | undefined;
  password: string | undefined;
  description: string | undefined;
  isAdmin: boolean;
  options: string | undefined;
  idZuModell: number;
  idFirma: number;
  idGruppe: number;
  idVorgesetzter: number;
  idStellvertreter: number;
  eMail: string | undefined;
  chronoUserRights: ChronoUserRights;
}

export interface PersonDateRange {
  personID: number;
  startDate: string;
  endDate: string;
}

export interface ChronoUserPersonDateRange extends PersonDateRange {
  chrnoUserID: number;
}

export enum ChronoUserPersonalRights {
  NoRights = 0,
  ReadWrite = 1,
  ReadOnly = 2,
}

export interface ChronoUserRights {
  order: boolean;
  personal: ChronoUserPersonalRights;
  department: boolean;
  customer: boolean;
  costCenter: boolean;
  timeModel: boolean;
  extras: boolean;
  visum: boolean;
  presenceList: boolean;
  absencePlaning: boolean;
  readPresenceList: ChronoUserRightsEnum;
  readAbsencePlaning: ChronoUserRightsEnum;
  personalRights: ChronoUserRightsEnum;
  location: boolean;
  presenceListDetails: boolean;
}

export enum ChronoUserRightsEnum {
  Firma = 0,
  Department = 1,
  Person = 2,
  Filiale = 3,
  Group = 4,
  Hierarchical = 5,
}

export enum ChronoVersionEnum {
  Standard = 0,
  Proffesional = 1,
  Enterprise = 2,
}

export interface ComeAndGoRequest {
  controllerId: string | undefined;
  personId: number;
  time: string;
}

export interface CostCenterChangeRequest {
  controllerId: string | undefined;
  personId: number;
  newCostCenterId: number;
}

export interface CostCenterListItem {
  id: number;
  number: string | undefined;
  name: string | undefined;
  costRate: number;
}

export interface CostCenterListParams {
  personID: number;
  orderID: number;
  pageNumber: number;
  pageSize: number;
  filterValue: string | undefined;
  filterAll: boolean;
  name: boolean;
  number: boolean;
}

export interface CostCenterListRequest {
  controllerId: string | undefined;
  personId: number;
  orderId: number;
  filterValue: string | undefined;
}

export interface CostCenterListResponse {
  culture: string | undefined;
  costCenters: CostCenterListItem[] | undefined;
}

export interface CostCenterListResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: CostCenterListResponse;
}

export interface CostCenterModel {
  id: number;
  number: string | undefined;
  name: string | undefined;
  costRate: number;
  deleted: boolean;
  active: boolean;
  department: DepartmentModel;
}

export interface CostCenterQuery extends PagedQuery {
  id: number | undefined;
  number: string | undefined;
  name: string | undefined;
  costRate: number | undefined;
  active: boolean | undefined;
  deleted: boolean | undefined;
  departmentID: number | undefined;
  departmentNumber: string | undefined;
  departmentName: string | undefined;
  departmentDeleted: boolean | undefined;
}

export interface CustomerListItem {
  customerID: number;
  customerNumber: string | undefined;
  customerName: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  phoneNumber: string | undefined;
  faxNumber: string | undefined;
}

export interface CustomerModel {
  id: number;
  number: string | undefined;
  name: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  phoneNumber: string | undefined;
  eMail: string | undefined;
  faxNumber: string | undefined;
  contactGender: boolean;
  contactPersonLastName: string | undefined;
  contactPersonFirstName: string | undefined;
  deleted: boolean;
  department: string | undefined;
}

export interface CustomerPaging {
  pageNumber: number;
  pageSize: number;
  filterValue: string | undefined;
  filterAll: boolean;
  customerNumber: boolean;
  customerName: boolean;
  address: boolean;
  zip: boolean;
  city: boolean;
}

export interface DateCheckResult {
  chronoLockDate: TaskResultWithKey;
  yearOpen: TaskResultWithKey;
}

export interface DatePersonRequest {
  idPerson: number;
  date: string;
}

export interface DateRange {
  start: string;
  end: string;
}

export interface DayOverTimeLevelHoursModel {
  from: number;
  to: number;
  surcharge: number;
  account: AccountModel;
  surchargeAccont: AccountModel;
}

export interface DayOverTimeLevelTimeModel {
  from: string;
  to: string;
  surcharge: number;
  account: AccountModel;
  surchargeAccont: AccountModel;
}

export interface DayOverTimeModel {
  id: number;
  surchargeToOrder: boolean;
  name: string | undefined;
  level1Time: DayOverTimeLevelTimeModel;
  level2Time: DayOverTimeLevelTimeModel;
  level1Hours: DayOverTimeLevelHoursModel;
  level2Hours: DayOverTimeLevelHoursModel;
}

export interface DaySettings {
  id: number;
  timeModelID: number;
  day: number;
  hours: number;
  break: BreakModel;
  vorNachlaufZeit: VorNachlaufZeitModel;
  dayOverTime: DayOverTimeModel;
  blockTime: BlockTimeModel;
  autoGo: AutoGoModel;
}

export interface DefaultWorkModelForPerson {
  id: number;
  active: boolean;
  personID: number;
  order: OrderModel;
  costCenter: CostCenterModel;
  operation: OperationModel;
  orderSelection: boolean;
  costCenterSelection: boolean;
  allowOnlyPreCalculatedCostCenter: boolean;
  allowOnlyPreCalculatedOperations: boolean;
  hasPassword: boolean;
  inCompany: boolean;
}

export interface DefaultWorkModelListTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: DefaultWorkModel[] | undefined;
}

export interface DefaultWorkModelPagedResult {
  items: DefaultWorkModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface DefaultWorkModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: DefaultWorkModelPagedResult;
}

export interface DefaultWorkQuery extends PagedQuery {
  id: number | undefined;
  active: boolean | undefined;
  personID: number | undefined;
  personNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  orderID: number | undefined;
  orderNumber: string | undefined;
  costCenterID: number | undefined;
  costCenterNumber: string | undefined;
  operationID: number | undefined;
  operation: string | undefined;
  hasPassword: boolean | undefined;
  inCompany: boolean | undefined;
  branchID: number | undefined;
  departmentID: number | undefined;
  groupID: number | undefined;
  showFuture: boolean | undefined;
}

export interface DepartmentModel extends BaseItemModel {
  number: string | undefined;
  name: string | undefined;
  deleted: boolean;
}

export interface DepartmentModelPagedResult {
  items: DepartmentModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface DepartmentModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: DepartmentModelPagedResult;
}

export interface DepartmentQuery extends PagedQuery {
  id: number | undefined;
  number: string | undefined;
  name: string | undefined;
  deleted: boolean | undefined;
}

export interface DepotFiles {
  documents: DocumentFiles;
  pictures: PictureFiles;
}

export interface DepotFilesTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: DepotFiles;
}

export interface DistributeTimeEntry {
  startTimeEntryID: number;
  endTimeEntryID: number;
  orderID: number;
  costCenterID: number;
  admiaUserID: number;
  amount: number;
  operation: string | undefined;
  note: string | undefined;
}

export interface DocumentFiles {
  personFiles: PersonDocuments[] | undefined;
  orderFiles: OrderDocumentFiles[] | undefined;
  generalOrderFiles: string[] | undefined;
}

export enum EMailBodyType {
  HTML = 0,
  Text = 1,
}

export interface EMailToSend {
  sender: string | undefined;
  recipients: string[] | undefined;
  ccRecipients: string[] | undefined;
  subject: string | undefined;
  body: string | undefined;
  attachments: string[] | undefined;
  type: EMailBodyType;
}

export interface EMailWithAttatchment extends EMailToSend {
  attachment: Base64Attachment;
}

export interface EmailMessageModel {
  message: string | undefined;
  idPerson: number;
}

export interface ExpenseApiModel extends BaseOrderPersonItem {
  id: number;
  description: string | undefined;
  quantity: number;
  unit: string | undefined;
  price: number;
  paidDate: string;
  linkedTimeEnty: boolean;
  timeEntryID: number;
  number: string | undefined;
  description2: string | undefined;
  paidOut: boolean;
  note: string | undefined;
  dateEdited: string;
  merchantName: string | undefined;
  merchantAddress: string | undefined;
  taxDetails: string | undefined;
  transactionDate: string;
  scanResultJSON: string | undefined;
  file: FileData;
}

export interface ExpenseApiModelPagedResult {
  items: ExpenseApiModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface ExpenseApiModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: ExpenseApiModelPagedResult;
}

export interface ExpenseApiModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: ExpenseApiModel;
}

export interface ExpenseCatalogueModel {
  id: number;
  number: string | undefined;
  barcode: string | undefined;
  description: string | undefined;
  description2: string | undefined;
  quantity: number;
  unit: string | undefined;
  price: number;
  barcodeID: string | undefined;
  note: string | undefined;
  dateEdited: string;
}

export interface ExpenseCatalogueModelPagedResult {
  items: ExpenseCatalogueModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface ExpenseCatalogueQuery extends PagedQuery {
  id: number | undefined;
  number: string | undefined;
  barcode: string | undefined;
  description: string | undefined;
  description2: string | undefined;
  quantity: string | undefined;
  quantityFrom: number | undefined;
  quantityTo: number | undefined;
  unit: string | undefined;
  price: string | undefined;
  priceFrom: number | undefined;
  priceTo: number | undefined;
  barcodeID: string | undefined;
  note: string | undefined;
}

export interface ExpenseQuery extends PagedQuery {
  id: number | undefined;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  dateString: string | undefined;
  description: string | undefined;
  quantityFrom: number | undefined;
  quantityTo: number | undefined;
  quantity: string | undefined;
  unit: string | undefined;
  priceFrom: number | undefined;
  priceTo: number | undefined;
  price: string | undefined;
  paidDateFrom: string | undefined;
  paidDateTo: string | undefined;
  paidDateString: string | undefined;
  timeEntryID: number | undefined;
  number: string | undefined;
  description2: string | undefined;
  paidOut: boolean | undefined;
  note: string | undefined;
  dateEditedFrom: string | undefined;
  dateEditedTo: string | undefined;
  dateEditedString: string | undefined;
  dateEdited: string | undefined;
  merchantName: string | undefined;
  merchantAddress: string | undefined;
  taxDetails: string | undefined;
  transactionDateFrom: string | undefined;
  transactionDateTo: string | undefined;
  transactionDateString: string | undefined;
  transactionDate: string | undefined;
  scanResultJSON: string | undefined;
  orderID: number | undefined;
  orderNumber: string | undefined;
  orderName: string | undefined;
  orderDescription: string | undefined;
  personalID: number | undefined;
  personalNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
}

export interface FileData {
  fileName: string | undefined;
  fileUrl: string | undefined;
  fileServerPath: string | undefined;
  isRapport: boolean;
}

export interface FileDataTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: FileData;
}

export interface FileRelationData extends FileData {
  order: OrderModel;
  person: PersonalApiModel;
  note: NoteApiModel;
  expense: ExpenseApiModel;
}

export interface FilialeListItem {
  idFirma: number;
  firma: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  country: string | undefined;
  phoneNumber: string | undefined;
  faxNumber: string | undefined;
  eMail: string | undefined;
  idHauptFirma: number;
}

export interface FingerPrintInfoResponse {
  culture: string | undefined;
  templates: string[] | undefined;
}

export interface FingerPrintInfoResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: FingerPrintInfoResponse;
}

export interface GlobalLockDateQueryModel extends PagedQuery {
  globalLockDate: string | undefined;
  globalLockDateFrom: string | undefined;
  globalLockDateTo: string | undefined;
}

export interface GroupMembersModel {
  id: number;
  personID: number;
  groupID: number;
  active: boolean;
  leader: boolean;
}

export interface GroupModel extends BaseGroupModel {
  members: GroupMembersModel[] | undefined;
}

export interface GroupPersonAssignmentModel extends BaseGroupModel {
  personID: number;
  active: boolean;
}

export interface HolidayDefinitionsModel {
  id: number;
  idHoliday: number;
  ageFrom: number | undefined;
  ageTo: number | undefined;
  workYearsFrom: number | undefined;
  workYearsTo: number | undefined;
  year: boolean;
  holidayWeeks: number;
}

export interface HolidayModel extends BaseItemModel {
  name: string | undefined;
  holidayDefinitions: HolidayDefinitionsModel[] | undefined;
}

export interface HolidayModelPagedResult {
  items: HolidayModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface HolidayModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: HolidayModelPagedResult;
}

export interface HolidayQuery extends PagedQuery {
  id: number | undefined;
  name: string | undefined;
  idDefinition: number | undefined;
  ageFromFrom: number | undefined;
  ageFromTo: number | undefined;
  ageToFrom: number | undefined;
  ageToTo: number | undefined;
  workYearsFromFrom: number | undefined;
  workYearsFromTo: number | undefined;
  workYearToFrom: number | undefined;
  workYearToTo: number | undefined;
  holidayWeeksFrom: number | undefined;
  holidayWeeksTo: number | undefined;
  year: boolean | undefined;
}

export interface InitalPasswordModel {
  persons: PersonalApiModel[] | undefined;
  csvList: string | undefined;
}

export interface InitalPasswordModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: InitalPasswordModel;
}

export interface InitalPasswordParameter {
  persons: PersonalApiModel[] | undefined;
  allWithNoPassword: boolean;
}

export interface InitialWorkInfo {
  personID: number;
  workInfo: WorkInfo;
}

export interface Int32TaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: number;
}

export interface Int64TaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: number;
}

export interface ItemAuthorisation {
  view: boolean;
  detailView: boolean;
  edit: boolean;
  delete: boolean;
  hasVisum: boolean;
  visumRemovalbe: boolean;
  reason: string | undefined;
}

export interface LanguagePersonModel {
  language: string | undefined;
  personID: number;
}

export interface LogOutInfo {
  uniqueID: string | undefined;
  personID: number;
}

export interface LoginErrorResponse {
  password: string | undefined;
  personalNR: string | undefined;
  general: string | undefined;
}

export interface LoginParameter {
  licenceNumber: string | undefined;
  uniqueID: string | undefined;
  deviceName: string | undefined;
  number: string | undefined;
  password: string | undefined;
  urlType: URLTypeEnum;
}

export interface ManualGehenTime {
  idPerson: number;
  gehenTime: string;
}

export interface MaterialCatalogueListItem {
  materialCatalogueID: number;
  groupID: number;
  number: string | undefined;
  name: string | undefined;
  description: string | undefined;
  quantity: number;
  unit: string | undefined;
  price: number;
  barcodeID: string | undefined;
  lagerOrt: string | undefined;
}

export interface MaterialCatalogueListItemPagedResult {
  items: MaterialCatalogueListItem[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface MaterialCatalogueListItemQuery extends PagedQuery {
  materialCatalogueID: number | undefined;
  groupID: number | undefined;
  number: string | undefined;
  name: string | undefined;
  description: string | undefined;
  quantity: number | undefined;
  unit: string | undefined;
  price: number | undefined;
  barcodeID: string | undefined;
  lagerOrt: string | undefined;
}

export interface MaterialModel extends BaseOrderPersonItem {
  id: number;
  description: string | undefined;
  description2: string | undefined;
  quantity: number;
  unit: string | undefined;
  price: number;
  planQuantity: number;
  planUnit: string | undefined;
  planPrice: number;
  timeEntryID: number;
  linkTimeEntry: boolean;
  number: string | undefined;
  note: string | undefined;
  dateEdit: string;
  typ: number;
  total: number;
  planTotal: number;
}

export interface MaterialModelPagedResult {
  items: MaterialModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface MaterialModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: MaterialModelPagedResult;
}

export interface MaterialModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: MaterialModel;
}

export interface MaterialQuery extends PagedQuery {
  id: number | undefined;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  date: string | undefined;
  description: string | undefined;
  quantityFrom: number | undefined;
  quantityTo: number | undefined;
  quantity: string | undefined;
  unit: string | undefined;
  priceFrom: number | undefined;
  priceTo: number | undefined;
  price: string | undefined;
  typ: number | undefined;
  timeEntryID: number | undefined;
  number: string | undefined;
  description2: string | undefined;
  note: string | undefined;
  dateEditFrom: string | undefined;
  dateEditTo: string | undefined;
  dateEdit: string | undefined;
  orderID: number | undefined;
  orderNumber: string | undefined;
  personalID: number | undefined;
  personalNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
}

export interface MultiOrderItemModel {
  orderID: number;
  costCenterID: number;
  operationID: number;
  operation: string | undefined;
  split: number;
}

export interface MultiOrderList {
  personID: number;
  orders: MultiOrderItemModel[] | undefined;
}

export interface NewNoteParams {
  linkTimeEntry: boolean;
  newNote: NoteListItem;
}

export interface NewQuantityParams {
  linkTimeEntry: boolean;
  newQuantity: QuantityListItem;
}

export interface NewTimeEntryChrono extends NewTimeEntry {
  modUserName: string | undefined;
}

export interface NewVisumParameter {
  idPerson: number;
  idAdmiaUser: number;
  visumDate: string;
}

export interface NoteApiTimeEntryModel {
  id: number;
  timeEntryID: number;
  order: OrderModel;
  person: PersonalApiModel;
  costCenter: CostCenterModel;
  date: string;
  editDate: string;
  exchangeDate: string;
  note: string | undefined;
  value: string | undefined;
  day: string | undefined;
  withImage: boolean;
  imageUrl: string | undefined;
}

export interface NoteApiModel extends NoteApiTimeEntryModel {
  timeEntry: TimeEntryModel;
}

export interface NoteFiles {
  note: NoteApiModel;
  files: FileData[] | undefined;
}

export interface NoteFilesTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: NoteFiles;
}

export interface NoteListItem {
  noteID: number;
  orderID: number;
  orderNumber: string | undefined;
  personID: number;
  costCenterID: number;
  date: string;
  dateTimeEntry: string | undefined;
  note: string | undefined;
  costCenterNumber: string | undefined;
  costCenterName: string | undefined;
  personNR: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  editAllowed: boolean;
  timeEntryID: number;
  fremdID: string | undefined;
}

export interface NoteListParameters {
  orderID: number;
  personID: number;
  admiaUserID: number;
  pageNumber: number;
  pageSize: number;
  filterValue: string | undefined;
  filterAll: boolean;
  note: boolean;
  costCenterNumber: boolean;
  costCenterName: boolean;
  personNR: boolean;
  firstName: boolean;
  lastName: boolean;
}

export interface OperationChangeRequest {
  controllerId: string | undefined;
  personId: number;
  operationText: string | undefined;
}

export interface OperationListItem {
  aksPlanID: number;
  orderID: number;
  operation: string | undefined;
  note: string | undefined;
  costCenterNumber: string | undefined;
  costCenterName: string | undefined;
  costCenterID: number;
  barcodeID: string | undefined;
}

export interface OperationListParams {
  personID: number;
  orderID: number;
  pageNumber: number;
  pageSize: number;
  filterValue: string | undefined;
  filterAll: boolean;
  operation: boolean;
  note: boolean;
  costCenterNumber: boolean;
  costCenterName: boolean;
}

export interface OperationModel {
  id: number;
  orderID: number;
  operation: string | undefined;
  note: string | undefined;
  costCenter: CostCenterModel;
  barcodeID: string | undefined;
  share: number;
  planStart: string;
  planEnd: string;
  planTime: number;
}

export enum OperationStateEnum {
  Selectable = 0,
  Inputable = 1,
  Both = 2,
  NotSelectable = 3,
  UseDefault = 4,
}

export interface OrderChangeRequest {
  controllerId: string | undefined;
  personId: number;
  newOrderId: number;
}

export interface OrderDocumentFiles {
  order: OrderModel;
  files: FileData[] | undefined;
  reportFiles: FileData[] | undefined;
}

export interface OrderFiles {
  order: OrderModel;
  pictures: FileData[] | undefined;
  documents: FileData[] | undefined;
  reports: FileData[] | undefined;
  generalDocuments: FileData[] | undefined;
}

export interface OrderFilesTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: OrderFiles;
}

export interface OrderInfo {
  number: string | undefined;
  name: string | undefined;
  description: string | undefined;
  customerID: number;
  customerName: string | undefined;
  isproject: boolean;
  projectID: number;
  startDate: string;
  endDate: string;
  active: boolean;
}

export interface OrderListItem {
  orderID: number;
  orderNumber: string | undefined;
  orderName: string | undefined;
  orderDescription: string | undefined;
  customerName: string | undefined;
  customerNumber: string | undefined;
  customerID: number;
}

export interface Paging {
  personID: number;
  pageNumber: number;
  pageSize: number;
}

export interface OrderListParameters extends Paging {
  filterValue: string | undefined;
  filterAll: boolean;
  orderNumber: boolean;
  orderName: boolean;
  orderDescription: boolean;
  customerName: boolean;
  customerNumber: boolean;
}

export interface OrderListRequest {
  controllerId: string | undefined;
  personId: number;
  filterValue: string | undefined;
}

export interface OrderListResponse {
  culture: string | undefined;
  orders: OrderListItem[] | undefined;
}

export interface OrderListResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: OrderListResponse;
}

export interface OrderModel {
  id: number;
  projectID: number;
  number: string | undefined;
  name: string | undefined;
  description: string | undefined;
  isProject: boolean;
  dateOne: string;
  dateTwo: string;
  dateThree: string;
  active: boolean;
  deleted: boolean;
  orderType: number;
  customer: CustomerModel;
}

export interface OrderNumber {
  number: string | undefined;
}

export interface OrderPictureFiles {
  order: OrderModel;
  noteFiles: NoteFiles[] | undefined;
  files: FileData[] | undefined;
}

export interface OrderPreCalcInfo extends OrderListItem {
  preCalcCostCenters: PreCalcCostCenter[] | undefined;
  preCalcOperations: PreCalcOperation[] | undefined;
}

export interface OrderQuery extends PagedQuery {
  id: number | undefined;
  projectID: number | undefined;
  number: string | undefined;
  name: string | undefined;
  description: string | undefined;
  isProject: boolean | undefined;
  dateOneFrom: string | undefined;
  dateOneTo: string | undefined;
  dateTwoFrom: string | undefined;
  dateTwoTo: string | undefined;
  dateThreeFrom: string | undefined;
  dateThreeTo: string | undefined;
  active: boolean | undefined;
  deleted: boolean | undefined;
  orderType: number | undefined;
  customerID: number | undefined;
  customerNumber: string | undefined;
  customerName: string | undefined;
}

export interface PasswordPersonModel {
  password: string | undefined;
  personID: number;
}

export interface PersonAndDay {
  personID: number;
  date: string;
}

export interface PersonDataModel {
  id: number;
  gender: boolean;
  number: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  birthday: string;
  email: string | undefined;
  emailPrivate: string | undefined;
  phone: string | undefined;
  phonePrivate: string | undefined;
  mobilePhone: string | undefined;
  language: number;
  profession: string | undefined;
  bank: string | undefined;
  insuranceNumber: string | undefined;
  note: string | undefined;
  personalCostRate: number;
  password: string | undefined;
  deleted: boolean;
  emailSerialPrint: boolean;
  emailPrivateSerialPrint: boolean;
}

export interface PersonDataModelPagedResult {
  items: PersonDataModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface PersonDataModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonDataModelPagedResult;
}

export interface PersonDataModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonDataModel;
}

export interface PersonDocuments {
  person: PersonalApiModel;
  files: FileData[] | undefined;
}

export interface PersonFiles {
  person: PersonalApiModel;
  pictures: FileData[] | undefined;
  documents: FileData[] | undefined;
}

export interface PersonFilesTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonFiles;
}

export interface PersonOptionsModel {
  authorization: PersonalAuthorization;
  emailSerialPrint: boolean;
  emailPrivateSerialPrint: boolean;
  approvalMandatory: boolean;
  onSerialPrints: boolean;
  allCostCenters: boolean;
  reductFromSaldo: boolean;
  hideFerienInTagen: boolean;
}

export interface PersonQueryModel extends PagedQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  gender: boolean | undefined;
  number: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  birthday: string | undefined;
  birthdayFrom: string | undefined;
  birthdayTo: string | undefined;
  emailMessage: string | undefined;
  email: string | undefined;
  emailPrivate: string | undefined;
  phone: string | undefined;
  phonePrivate: string | undefined;
  mobilePhone: string | undefined;
  language: string | undefined;
  profession: string | undefined;
  bank: string | undefined;
  insuranceNumber: string | undefined;
  note: string | undefined;
  personalCostRate: number | undefined;
  personalCostRateFrom: number | undefined;
  personalCostRateTo: number | undefined;
  password: string | undefined;
  deleted: boolean | undefined;
  emailSerialPrint: boolean | undefined;
  emailPrivateSerialPrint: boolean | undefined;
}

export interface PersonTimeModelAssignment {
  from: string;
  to: string;
  person: PersonDataModel;
  timeModel: TimeModelModel;
}

export interface PersonTimeModelAssignmentListTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonTimeModelAssignment[] | undefined;
}

export interface PersonalApiModel extends PersonDataModel {
  optionsString: string | undefined;
  comeAndGo: boolean;
  orderSelection: boolean;
  allCostCenters: boolean;
  reductFromSaldo: boolean;
  costCenterSelection: boolean;
  onSerialPrint: boolean;
  working: boolean;
  warning: boolean;
  inCompany: boolean;
  costRate: number;
  emailMessage: string | undefined;
  defaultCostCenter: CostCenterModel;
  defaultWork: DefaultWorkModelForPerson;
  assignments: PersonalAssignmentModel[] | undefined;
  currentAssignment: PersonalAssignmentModel;
  options: PersonOptionsModel;
  authorisation: ItemAuthorisation;
  personalWorkInfo: PersonalWorkInfo;
  groups: GroupPersonAssignmentModel[] | undefined;
  activeGroup: GroupPersonAssignmentModel;
  terminalGroup: TerminalGroupModel;
}

export interface PersonalApiModelPagedResult {
  items: PersonalApiModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface PersonalApiModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonalApiModelPagedResult;
}

export interface PersonalApiModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonalApiModel;
}

export interface PersonalAssignmentModel {
  id: number;
  personalID: number;
  entryDate: string;
  exitDate: string;
  branch: BranchModel;
  holiday: HolidayModel;
  superior: UserModel;
  department: DepartmentModel;
}

export interface PersonalAuthorization {
  timeEdit: boolean;
  comeAndGo: boolean;
  orderSelect: boolean;
  costCenterSelect: boolean;
  comeAndGoEdit: boolean;
  absenceEdit: boolean;
  changeEdit: boolean;
  absenceAsk: boolean;
  timeVisum: boolean;
}

export interface PersonalDefaultWorkModel {
  orderID: number;
  costCenterID: number;
}

export interface PersonalGroupListItem {
  idPersonalGroup: number;
  name: string | undefined;
  extension: string | undefined;
}

export interface PersonalID {
  personID: number;
}

export interface PersonalIdentificationAuth {
  successful: boolean;
  data: PersonalIdentificationDataModel;
  token: string | undefined;
  message: string | undefined;
}

export interface PersonalIdentificationDataModel {
  id: number;
  idPerson: number;
  chipNumber: string | undefined;
  terminalOld: boolean;
  type: string | undefined;
}

export interface PersonalIdentificationDataModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonalIdentificationDataModel;
}

export enum PersonalIdentificationEnum {
  RfId = 0,
  FingerPrint = 1,
}

export interface PersonalIdentificationParameter {
  data: PersonalIdentificationDataModel;
  terminalId: number;
}

export interface PersonalIdentificationQueryModel extends PagedQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  idPerson: number | undefined;
  idPersonFrom: number | undefined;
  idPersonTo: number | undefined;
  chipNumber: string | undefined;
  terminalOld: boolean | undefined;
  type: string | undefined;
}

export interface PersonalIdentificationRequest {
  controllerId: string | undefined;
  tag: string | undefined;
  personNumber: string | undefined;
  type: PersonalIdentificationEnum;
}

export interface PersonalIdentificationResponse {
  culture: string | undefined;
}

export interface PersonalIdentificationResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonalIdentificationResponse;
}

export interface PersonalInfoRequest {
  controllerId: string | undefined;
  personId: number;
}

export interface PersonalInfoResponse {
  culture: string | undefined;
  info: TerminalPersonInfo;
  comeAndGo: TerminalComeAndGoInfo;
  order: TerminalOrderInfo;
  coseCenter: TerminalCoseCenterInfo;
  operation: TerminalOperationInfo;
  saldos: TerminalSaldo[] | undefined;
}

export interface PersonalInfoResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonalInfoResponse;
}

export interface PersonalLicence {
  licence: string | undefined;
}

export interface PersonalNumber {
  personalNr: string | undefined;
}

export interface PersonalQuery extends PagedQuery {
  authorisationFrom: string | undefined;
  authorisationTo: string | undefined;
  id: number | undefined;
  gender: boolean | undefined;
  number: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  birthday: string | undefined;
  birthdayFrom: string | undefined;
  birthdayTo: string | undefined;
  comeTimeString: string | undefined;
  goTimeString: string | undefined;
  birthdayString: string | undefined;
  email: string | undefined;
  emailSerialPrint: boolean | undefined;
  emailPrivate: string | undefined;
  emailPrivateSerialPrint: boolean | undefined;
  phone: string | undefined;
  phonePrivate: string | undefined;
  mobilePhone: string | undefined;
  language: string | undefined;
  profession: string | undefined;
  bank: string | undefined;
  insuranceNumber: string | undefined;
  note: string | undefined;
  costRate: number | undefined;
  password: string | undefined;
  deleted: boolean | undefined;
  inCompany: boolean | undefined;
  entryDateFrom: string | undefined;
  entryDateTo: string | undefined;
  entryDateString: string | undefined;
  exitDateFrom: string | undefined;
  exitDateTo: string | undefined;
  exitDateString: string | undefined;
  branchID: number | undefined;
  branch: string | undefined;
  holidayID: number | undefined;
  holidayName: string | undefined;
  superiorID: number | undefined;
  departmentID: number | undefined;
  departmentNumber: string | undefined;
  departmentName: string | undefined;
  groupID: number | undefined;
  groupName: string | undefined;
  groupAddition: string | undefined;
  currentOrderName: string | undefined;
  currentOrderNumber: string | undefined;
  currentOrderDescription: string | undefined;
  customerNumber: string | undefined;
  customerName: string | undefined;
  currentCostCenterName: string | undefined;
  currentCostCenterNumber: string | undefined;
  defaultCostCenterID: number | undefined;
  defaultCostCenterName: string | undefined;
  defaultCostCenterNumber: string | undefined;
  currentOperation: string | undefined;
}

export interface PersonalSelect {
  firstname: string | undefined;
  lastname: string | undefined;
  nummer: string | undefined;
  id: number;
  chronoUser: boolean;
}

export interface PersonalValidateRequest {
  controllerId: string | undefined;
  personNumber: string | undefined;
  tag: string | undefined;
}

export interface PersonalValidateResponse {
  culture: string | undefined;
  number: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
}

export interface PersonalValidateResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: PersonalValidateResponse;
}

export interface PersonalWorkInfo {
  working: boolean;
  order: OrderModel;
  orderTime: string;
  costCenter: CostCenterModel;
  costCenterTime: string;
  operation: OperationModel;
  operationTime: string;
  comeTime: string;
  goTime: string;
  openCome: boolean;
  comeIsInThePast: boolean;
  goIsInThePast: boolean;
  absence: AccountModel;
  warning: boolean;
}

export interface PictureFiles {
  personFiles: PersonDocuments[] | undefined;
  orderFiles: OrderPictureFiles[] | undefined;
}

export interface PreCalculation {
  orderID: number;
  name: string | undefined;
  description: string | undefined;
  activ: boolean;
  preCalcID: number;
  planKosten: number;
  share: number;
  barcodeID: string | undefined;
  planTimeHours: number;
  planStart: string | undefined;
  planEnd: string | undefined;
}

export interface PreCalcCostCenter extends PreCalculation {
  costCenterID: number;
  costCenterNumber: string | undefined;
  costCenterName: string | undefined;
  costRate: number;
}

export interface PreCalcOperation extends PreCalcCostCenter {
  operation: string | undefined;
  note: string | undefined;
}

export interface PresenceListItem {
  idPerson: number;
  personalNumber: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
  address: string | undefined;
  zip: string | undefined;
  city: string | undefined;
  phoneNumber: string | undefined;
  privatePhoneNumber: string | undefined;
  mobileNumber: string | undefined;
  entryDate: string;
  departmentID: number;
  departmentNumber: string | undefined;
  departmentName: string | undefined;
  working: boolean;
  startTime: string;
  stopTime: string;
  orderID: number;
  orderName: string | undefined;
  orderNumber: string | undefined;
  operation: string | undefined;
  costCenterID: number;
  costCenterName: string | undefined;
  costCenterNumber: string | undefined;
  edit: boolean;
  color: string | undefined;
}

export interface PresenceListParamters {
  personID: number;
  chronoUserID: number;
  filterValue: string | undefined;
  filterAll: boolean;
  personalNumber: boolean;
  firstName: boolean;
  lastName: boolean;
  orderNumber: boolean;
  orderName: boolean;
  costCenterName: boolean;
  costCenterNumber: boolean;
  operation: boolean;
}

export interface QuantityListItem {
  quantityID: number;
  orderID: number;
  personID: number;
  quantity: number;
  operation: string | undefined;
  date: string;
  personNR: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
  editAllowed: boolean;
}

export interface QuantityListParameter {
  orderID: number;
  personID: number;
  admiaUserID: number;
  pageNumber: number;
  pageSize: number;
  filterValue: string | undefined;
  filterAll: boolean;
  operation: boolean;
  quantity: boolean;
  personNR: boolean;
  firstName: boolean;
  lastName: boolean;
}

export interface QuantityModel extends BaseOrderPersonItem {
  id: number;
  operation: string | undefined;
  quantity: number;
}

export interface QuantityQuery extends PagedQuery {
  id: number | undefined;
  quantity: number | undefined;
  operation: string | undefined;
  date: string | undefined;
  dateString: string | undefined;
  orderID: number | undefined;
  orderNumber: string | undefined;
  orderName: string | undefined;
  orderDescription: string | undefined;
  personID: number | undefined;
  personalNumber: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
}

export interface RangeOverTimeModel {
  id: number;
  name: string | undefined;
  weekSettings: RangeOvertimeSettingsModel;
  monthSettings: RangeOvertimeSettingsModel;
}

export interface RangeOvertimeSettingsModel {
  numberOfPeriods: number;
  hoursLimit: number;
  account: AccountModel;
  surchargePercentage: number;
  surchargeAccount: AccountModel;
  text: string | undefined;
}

export interface RegistrationRequest {
  controllerId: string | undefined;
  number: string | undefined;
}

export interface RegistrationResponse {
  culture: string | undefined;
}

export interface RegistrationResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: RegistrationResponse;
}

export interface ReportDetail {
  fullName: string | undefined;
  portrait: boolean;
}

export interface ReportEmailModel {
  reportParameter: ReportParameter;
  sender: string | undefined;
  path: string | undefined;
  subject: string | undefined;
  body: string | undefined;
  recipient: string[] | undefined;
  recipientCC: string[] | undefined;
}

export interface ReportInfo {
  fileName: string | undefined;
  description: string | undefined;
  isActive: boolean;
  custom: boolean;
  chrono: boolean;
  mobile: boolean;
  dashBaord: boolean;
  licencedUntil: string;
}

export interface ReportParameter {
  title: string | undefined;
  reportName: string | undefined;
  fileName: string | undefined;
  language: string | undefined;
  parameters: string[] | undefined;
}

export interface ReportSaveModel {
  reportParameter: ReportParameter;
  path: string | undefined;
}

export interface RequestedAbsencesListItem {
  idPerson: number;
  idAdmiaUser: number;
  personalNR: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
  idZeiten: number;
  datum: string;
  konto: string | undefined;
  name: string | undefined;
  zzm: string | undefined;
  email: string | undefined;
  emailSuperior: string | undefined;
  emailResponse: string | undefined;
  korrektur?: number;
}

export interface SQLQueryParameter {
  query: string | undefined;
  password: string | undefined;
}

export interface Saldo {
  accounts: Account[] | undefined;
}

export interface SaldoLimitModel {
  id: number;
  name: string | undefined;
  limits: SaldoLimitSettingModel[] | undefined;
}

export interface SaldoLimitSettingModel {
  id: number;
  saldoLimitID: number;
  account: AccountModel;
  maxSaldo: number;
  minSalod: number;
  period: number;
  toAccount: AccountModel;
  executionDay: number;
  text: string | undefined;
}

export interface Security {
  selectable: boolean;
  visible: boolean;
}

export interface StatusModel {
  servicePause: boolean;
  databaseOk: boolean;
  version: string | undefined;
  firmaName: string | undefined;
  dbInfoPath: string | undefined;
  chronoVersion: ChronoVersionEnum;
}

export interface StringResult {
  text: string | undefined;
}

export interface StringResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: StringResult;
}

export interface TaskResult {
  successful: boolean;
  message: string | undefined;
}

export interface TaskResultWithKey {
  successful: boolean;
  messageKey: string | undefined;
}

export interface TerminalComeAndGoInfo {
  isWorking: boolean;
}

export interface TerminalCoseCenterInfo {
  id: number;
  number: string | undefined;
  name: string | undefined;
}

export interface TerminalGroupModel {
  id: number;
  number: string | undefined;
  name: string | undefined;
}

export interface TerminalGroupModelPagedResult {
  items: TerminalGroupModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface TerminalGroupModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TerminalGroupModelPagedResult;
}

export interface TerminalGroupModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TerminalGroupModel;
}

export interface TerminalGroupQuery extends PagedQuery {
  id: number | undefined;
  number: string | undefined;
  name: string | undefined;
}

export interface TerminalInfo {
  chronoVersion: ChronoVersionEnum;
  readonly serverTime: string;
}

export interface TerminalInfoResponse {
  culture: string | undefined;
  info: TerminalInfo;
}

export interface TerminalInfoResponseTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TerminalInfoResponse;
}

export interface TerminalOperationInfo {
  id: number;
  number: string | undefined;
  name: string | undefined;
}

export interface TerminalOrderInfo {
  id: number;
  number: string | undefined;
  name: string | undefined;
}

export interface TerminalPersonInfo {
  id: number;
  number: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
}

export interface TerminalSaldo {
  name: string | undefined;
  saldoInHours: number;
  saldoInDays: number | undefined;
}

export interface TimeAndTokenModel {
  token: string | undefined;
  time: string;
}

export interface TimeEntryListItem {
  timeEntryID: number;
  personID: number;
  timeEntryPreviousID: number;
  timeEntryNextID: number;
  blockFinalisationID: number;
  korrektur: number;
  uzzm: string;
  uzeit: string;
  datum: string;
  allDay: boolean;
  zzm: number;
  erfTyp: number;
  orderID: number;
  orderNr: string | undefined;
  orderName: string | undefined;
  orderDescription: string | undefined;
  costCenterId: number;
  costCenterNumber: string | undefined;
  costCenterName: string | undefined;
  operation: string | undefined;
  absenceID: number;
  absenceCode: string | undefined;
  absenceName: string | undefined;
  absenceColor: number;
  isAbsence: boolean;
  cost: number;
  color: string | undefined;
  correctionIndicator: string | undefined;
  hasVisum: boolean;
  edit: TimeEntryEditEnum;
  switch: boolean;
  split: boolean;
  remove: boolean;
  note: NoteListItem;
}

export interface TimeEntryDeleteChrono extends TimeEntryListItem {
  modUserName: string | undefined;
  station: string | undefined;
}

export interface TimeEntryEdit {
  id: number;
  editorName: string | undefined;
  editDate: string;
  old: TimeEntryModel;
  new: TimeEntryModel;
  user: UserModel;
  visum: number;
  note: string | undefined;
  noteEamil: string | undefined;
  status: number;
}

export enum TimeEntryEditEnum {
  NotEditable = 0,
  WorkInfoEditable = 1,
  FullEdit = 2,
}

export interface TimeEntryListParamter extends Paging {
  start: string;
  end: string;
}

export interface TimeEntryListParamterAdmin extends Paging {
  start: string;
  end: string;
  admiaUserID: number;
}

export interface TimeEntryListWithTotal {
  dateRange: DateRange;
  timeEntryList: TimeEntryListItem[] | undefined;
  total: number;
  comeAndGoEdit: boolean;
}

export interface TimeEntryModel {
  id: number;
  date: string;
  time: string;
  timeAfterCalculation: string;
  hours: number;
  person: PersonalApiModel;
  account: AccountModel;
  order: OrderModel;
  costCenter: CostCenterModel;
  operation: OperationModel;
  operationText: string | undefined;
  costRate: number;
  type: number;
  correctionType: number;
  block: boolean;
  terminator: boolean;
  operationCode: string | undefined;
  idBarcode: string | undefined;
  deviceName: string | undefined;
  coordinates: string | undefined;
  changeLog: TimeEntryEdit[] | undefined;
  note: NoteApiTimeEntryModel;
}

export interface TimeEntryModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimeEntryModel;
}

export interface TimeEntryQuery extends PagedQuery {
  dateFrom: string | undefined;
  dateTo: string | undefined;
  timeFrom: string | undefined;
  timeTo: string | undefined;
  timeAfterCalculationFrom: string | undefined;
  timeAfterCalculationTo: string | undefined;
  hoursFrom: number | undefined;
  hoursTo: number | undefined;
  personID: number | undefined;
  personNumber: string | undefined;
  personLastName: string | undefined;
  personFirstName: string | undefined;
  accountID: number | undefined;
  accountKonto: string | undefined;
  accountName: string | undefined;
  orderID: number | undefined;
  orderProjectID: number | undefined;
  orderNumber: string | undefined;
  orderName: string | undefined;
  costCenterID: number | undefined;
  costCenterNumber: string | undefined;
  costCenterName: string | undefined;
  operationID: number | undefined;
  operationOperation: string | undefined;
  operationText: string | undefined;
  costRate: number | undefined;
  type: number | undefined;
  correctionType: number | undefined;
  block: boolean | undefined;
  terminator: boolean | undefined;
  operationCode: string | undefined;
  idBarcode: string | undefined;
  deviceName: string | undefined;
  coordinates: string | undefined;
}

export interface TimeEntrySimple {
  timeEntryID: number;
  personID: number;
  korrektur: number;
  uzzm: string;
  uzeit: string;
  datum: string;
  zzm: number;
  erfTyp: number;
  orderID: number;
  costCenterId: number;
  operation: string | undefined;
  isAbsence: boolean;
  isMulitOrder: boolean;
}

export interface TimeEntrySplit {
  personID: number;
  absenceID: number;
  startTimeEntryID: number;
  endTimeEntryID: number;
  orderID: number;
  costCenterID: number;
  operation: string | undefined;
  startTime: string;
  endTime: string;
  startTimeMin: string;
  endTimeMax: string;
}

export interface TimeEntrySplitChrono extends TimeEntrySplit {
  modUserName: string | undefined;
}

export interface TimeLineQuery extends PagedQuery {
  personID: number | undefined;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  validFrom: string | undefined;
  validTo: string | undefined;
}

export interface TimeModelModel {
  id: number;
  number: string | undefined;
  name: string | undefined;
  active: boolean;
  deleted: boolean;
  daySettings: DaySettings[] | undefined;
  protected: boolean;
  vorholtage: boolean;
  weekShouldTime: number;
  rangeOverTime: RangeOverTimeModel;
  saldoLimit: SaldoLimitModel;
}

export interface TimeModelModelPagedResult {
  items: TimeModelModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface TimeModelModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimeModelModelPagedResult;
}

export interface TimeModelModelTimelinePeriodicModel {
  personal: PersonDataModel[] | undefined;
  start: string;
  end: string;
  period: TimelinePeriod;
  periodLenght: number;
  items: TimeModelModel[] | undefined;
}

export interface TimeModelQuery extends PagedQuery {
  id: number | undefined;
  name: string | undefined;
  number: string | undefined;
  active: boolean | undefined;
  deleted: boolean | undefined;
  idRangeOverTime: number | undefined;
  rangeOverTimeName: string | undefined;
  saldoLimitID: number | undefined;
  saldoLimitName: string | undefined;
  protected: boolean | undefined;
  vorholtage: boolean | undefined;
  weekShouldTime: number | undefined;
}

export interface TimelineDataModel {
  id: number;
  date: string;
  toDate: string;
  person: PersonDataModel;
  authorisation: ItemAuthorisation;
}

export interface TimelineBranchDataModel extends TimelineDataModel {
  branch: BranchModel;
}

export interface TimelineBranchDataModelPagedResult {
  items: TimelineBranchDataModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface TimelineBranchDataModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineBranchDataModelPagedResult;
}

export interface TimelineBranchDataModelReplaceTimelineItem {
  oldAssignment: TimelineBranchDataModel;
  newAssignment: TimelineBranchDataModel;
  start: string;
  end: string;
}

export interface TimelineBranchDataModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineBranchDataModel;
}

export interface TimelineBranchDataModelTimelineItem {
  item: TimelineBranchDataModel;
  start: string;
  end: string;
}

export interface TimelineBranchQueryModel extends TimeLineQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  date: string | undefined;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  personIDFrom: number | undefined;
  personIDTo: number | undefined;
  personNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  branchID: number | undefined;
  branchIDFrom: number | undefined;
  branchIDTo: number | undefined;
  branchName: string | undefined;
}

export interface TimelineDepartmentDataModel extends TimelineDataModel {
  department: DepartmentModel;
}

export interface TimelineDepartmentDataModelBatch {
  personal: PersonDataModel[] | undefined;
  parameter: TimelineDepartmentDataModelTimelineItem;
}

export interface TimelineDepartmentDataModelBatchReplace {
  personal: PersonDataModel[] | undefined;
  parameter: TimelineDepartmentDataModelReplaceTimelineItem;
}

export interface TimelineDepartmentDataModelBatchResult {
  personId: number;
  message: string | undefined;
}

export interface TimelineDepartmentDataModelBatchResultListTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineDepartmentDataModelBatchResult[] | undefined;
}

export interface TimelineDepartmentDataModelPagedResult {
  items: TimelineDepartmentDataModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface TimelineDepartmentDataModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineDepartmentDataModelPagedResult;
}

export interface TimelineDepartmentDataModelReplaceTimelineItem {
  oldAssignment: TimelineDepartmentDataModel;
  newAssignment: TimelineDepartmentDataModel;
  start: string;
  end: string;
}

export interface TimelineDepartmentDataModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineDepartmentDataModel;
}

export interface TimelineDepartmentDataModelTimelineItem {
  item: TimelineDepartmentDataModel;
  start: string;
  end: string;
}

export interface TimelineDepartmentQueryModel extends TimeLineQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  date: string | undefined;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  personIDFrom: number | undefined;
  personIDTo: number | undefined;
  personNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  departmentID: number | undefined;
  departmentIDFrom: number | undefined;
  departmentIDTo: number | undefined;
  departmentName: string | undefined;
}

export interface TimelineHolidayDataModel extends TimelineDataModel {
  holiday: HolidayModel;
}

export interface TimelineHolidayDataModelBatch {
  personal: PersonDataModel[] | undefined;
  parameter: TimelineHolidayDataModelTimelineItem;
}

export interface TimelineHolidayDataModelBatchReplace {
  personal: PersonDataModel[] | undefined;
  parameter: TimelineHolidayDataModelReplaceTimelineItem;
}

export interface TimelineHolidayDataModelBatchResult {
  personId: number;
  message: string | undefined;
}

export interface TimelineHolidayDataModelBatchResultListTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineHolidayDataModelBatchResult[] | undefined;
}

export interface TimelineHolidayDataModelListTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineHolidayDataModel[] | undefined;
}

export interface TimelineHolidayDataModelPagedResult {
  items: TimelineHolidayDataModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface TimelineHolidayDataModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineHolidayDataModelPagedResult;
}

export interface TimelineHolidayDataModelReplaceTimelineItem {
  oldAssignment: TimelineHolidayDataModel;
  newAssignment: TimelineHolidayDataModel;
  start: string;
  end: string;
}

export interface TimelineHolidayDataModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineHolidayDataModel;
}

export interface TimelineHolidayDataModelTimelineItem {
  item: TimelineHolidayDataModel;
  start: string;
  end: string;
}

export interface TimelineHolidayQueryModel extends TimeLineQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  date: string | undefined;
  personIDFrom: number | undefined;
  personIDTo: number | undefined;
  personNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  holidayID: number | undefined;
  holidayIDFrom: number | undefined;
  holidayIDTo: number | undefined;
  holidayName: string | undefined;
}

export interface TimelineModelPeriodicBatch
  extends TimeModelModelTimelinePeriodicModel {}

export enum TimelinePeriod {
  Week = 0,
  Month = 1,
}

export interface TimelineSuperiorDataModel extends TimelineDataModel {
  user: UserModel;
}

export interface TimelineSuperiorDataModelPagedResult {
  items: TimelineSuperiorDataModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface TimelineSuperiorDataModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineSuperiorDataModelPagedResult;
}

export interface TimelineSuperiorDataModelReplaceTimelineItem {
  oldAssignment: TimelineSuperiorDataModel;
  newAssignment: TimelineSuperiorDataModel;
  start: string;
  end: string;
}

export interface TimelineSuperiorDataModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineSuperiorDataModel;
}

export interface TimelineSuperiorDataModelTimelineItem {
  item: TimelineSuperiorDataModel;
  start: string;
  end: string;
}

export interface TimelineSuperiorQueryModel extends TimeLineQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  date: string | undefined;
  personIDFrom: number | undefined;
  personIDTo: number | undefined;
  personNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  userID: number | undefined;
  userIDFrom: number | undefined;
  userIDTo: number | undefined;
  userName: string | undefined;
}

export interface TimelineTimeModelBatch {
  personal: PersonDataModel[] | undefined;
  assignment: TimelineTimeModelDataModelTimelineItem;
}

export interface TimelineTimeModelDataModel extends TimelineDataModel {
  timeModel: TimeModelModel;
}

export interface TimelineTimeModelDataModelPagedResult {
  items: TimelineTimeModelDataModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface TimelineTimeModelDataModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineTimeModelDataModelPagedResult;
}

export interface TimelineTimeModelDataModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineTimeModelDataModel;
}

export interface TimelineTimeModelDataModelTimelineItem {
  item: TimelineTimeModelDataModel;
  start: string;
  end: string;
}

export interface TimelineTimeModelQueryModel extends TimeLineQuery {
  timeModelID: number | undefined;
}

export interface TimelineTimeModelRepalce {
  oldAssignment: TimeModelModel;
  newAssignment: TimeModelModel;
  start: string;
  end: string;
}

export interface TimelineTimeModelReplaceBatch {
  personal: PersonDataModel[] | undefined;
  data: TimelineTimeModelRepalce;
}

export interface TimelineWorkPeriodDataModel extends TimelineDataModel {
  endDate: string;
  auto: boolean;
}

export interface TimelineWorkPeriodDataModelPagedResult {
  items: TimelineWorkPeriodDataModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface TimelineWorkPeriodDataModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineWorkPeriodDataModelPagedResult;
}

export interface TimelineWorkPeriodDataModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: TimelineWorkPeriodDataModel;
}

export interface TimelineWorkPeriodQueryModel extends TimeLineQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  date: string | undefined;
  endDate: string | undefined;
  endDateFrom: string | undefined;
  endDateTo: string | undefined;
  personIDFrom: number | undefined;
  personIDTo: number | undefined;
  personNumber: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
}

export interface ToggleModel {
  active: boolean;
  data: DefaultWorkModel[] | undefined;
}

export enum URLTypeEnum {
  Local = 0,
  Remote = 1,
}

export interface UserModel extends BaseItemModel {
  personalLinkID: number;
  isAdminOfLinkedPerson: boolean;
  departmentID: number;
  name: string | undefined;
  password: string | undefined;
  description: string | undefined;
  admin: boolean;
  options: string | undefined;
  branchID: number;
  groupID: number;
  superiorID: number;
  deputyID: number;
  email: string | undefined;
  userRights: UserRightsModel;
}

export interface UserModelPagedResult {
  items: UserModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface UserModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: UserModelPagedResult;
}

export interface UserModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: UserModel;
}

export interface UserModelTimelinePeriodicModel {
  personal: PersonDataModel[] | undefined;
  start: string;
  end: string;
  period: TimelinePeriod;
  periodLenght: number;
  items: UserModel[] | undefined;
}

export interface UserModelTimelinePeriodicModelTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: UserModelTimelinePeriodicModel;
}

export interface UserPersonDateModel {
  chronoUserID: number;
  personID: number;
  date: string;
}

export interface UserQuery extends PagedQuery {
  id: number | undefined;
  personalLinkID: number | undefined;
  departmentID: number | undefined;
  name: string | undefined;
  password: string | undefined;
  description: string | undefined;
  admin: boolean | undefined;
  options: string | undefined;
  branchID: number | undefined;
  groupID: number | undefined;
  superiorID: number | undefined;
  deputyID: number | undefined;
  email: string | undefined;
}

export interface UserRightsModel {
  order: ChronoUserPersonalRights;
  personal: ChronoUserPersonalRights;
  department: ChronoUserPersonalRights;
  customer: ChronoUserPersonalRights;
  costCenter: ChronoUserPersonalRights;
  timeModel: ChronoUserPersonalRights;
  extras: ChronoUserPersonalRights;
  visum: boolean;
  presenceList: boolean;
  absencePlaning: boolean;
  readPresenceList: ChronoUserRightsEnum;
  readAbsencePlaning: ChronoUserRightsEnum;
  personalRights: ChronoUserRightsEnum;
  location: boolean;
  presenceListDetails: boolean;
  tabRights: UserTabRights;
  userZeitenDelete: boolean;
}

export interface UserTabRights {
  report: boolean;
  timeEntries: boolean;
  timeModel: boolean;
  timeline: boolean;
  bookings: boolean;
  expenses: boolean;
  mail: boolean;
  personalData: boolean;
  options: boolean;
  warnings: boolean;
}

export interface VisumCheck {
  hasVisum: boolean;
  visumRemoveable: boolean;
  dateCheck: DateCheckResult;
  visumDate: string;
}

export interface VisumListItem {
  idVisum: number;
  idPerson: number;
  date: string;
  visum: number;
  typ: number;
  userName: string | undefined;
  datumMod: string;
}

export interface VisumPersonQueryModel extends PagedQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  personID: number | undefined;
  personIDFrom: number | undefined;
  personIDTo: number | undefined;
  personNumber: string | undefined;
  hasVisum: boolean | undefined;
  visumRemoveable: boolean | undefined;
  visumDate: string | undefined;
  visumDateFrom: string | undefined;
  visumDateTo: string | undefined;
}

export enum VisumStatusEnum {
  NotSignedButMandatory = 0,
  NotSignedNotMandatory = 1,
  SignedByPerson = 11,
  SignedBySupervisor = 12,
  SignedByManager = 13,
}

export interface VisumSuperiorQueryModel extends PagedQuery {
  id: number | undefined;
  idFrom: number | undefined;
  idTo: number | undefined;
  personID: number | undefined;
  personIDFrom: number | undefined;
  personIDTo: number | undefined;
  personNumber: string | undefined;
  userID: number | undefined;
  userIDFrom: number | undefined;
  userIDTo: number | undefined;
  userName: string | undefined;
  visumDate: string | undefined;
  visumDateFrom: string | undefined;
  visumDateTo: string | undefined;
  hasVisum: boolean | undefined;
  visumRemoveable: boolean | undefined;
}

export interface VorNachlaufZeitModel {
  id: number;
  name: string | undefined;
  vorlaufZeitFrom: string;
  vorlaufZeitTo: string;
  nachlaufZeitFrom: string;
  nachlaufZeitTo: string;
}

export interface WarningModel {
  id: number;
  idPerson: number;
  timeEntry: TimeEntryModel;
  expense: ExpenseApiModel;
  date: string;
  code: string | undefined;
  typ: number;
  warning: string | undefined;
}

export interface WarningModelPagedResult {
  items: WarningModel[] | undefined;
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  full: boolean;
  authorisation: boolean;
  readonly totalPages: number;
  totalActive: number;
  totalInactive: number;
  totalDeleted: number;
}

export interface WarningModelPagedResultTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: WarningModelPagedResult;
}

export interface WarningQuery extends PagedQuery {
  id: number | undefined;
  idPerson: number | undefined;
  timeEntryID: number | undefined;
  expenseID: number | undefined;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  code: string | undefined;
  typ: number | undefined;
  warning: string | undefined;
}

export interface WebAppSettingsModel {
  id: number;
  idPerson: number;
  idAdmiaUser: number;
  version: number;
  minorVersion: number;
  value: string | undefined;
}

export interface WebAppUser {
  id: number;
  number: string | undefined;
  language: string | undefined;
  firstname: string | undefined;
  lastname: string | undefined;
  token: string | undefined;
  serialNumber: string | undefined;
  userID: number;
  user: UserModel;
}

export interface WorkFlowModel {
  person: PersonalApiModel;
  user: UserModel;
  date: string | undefined;
  typ: number | undefined;
  userName: string | undefined;
  visum: number | undefined;
  visumStatus: VisumStatusEnum;
  visumStatusTyp: number | undefined;
  superiorID: number;
  selected: boolean;
}

export interface WorkFlowModelListTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: WorkFlowModel[] | undefined;
}

export interface WorkFlowQuery {
  userID: number;
  startDate: string;
  endDate: string;
  isAdmin: boolean;
}

export interface WorkInfo {
  order: WorkInfoOrder;
  costCenter: WorkInfoCostCenter;
  operation: WorkInfoOperation;
  absence: WorkInfoAbsence;
  currentNote: NoteListItem;
}

export interface WorkInfoAbsence {
  time: string | undefined;
  absence: AbsenceListItem;
  selectable: boolean;
  shouldBeSelectedNext: boolean;
}

export interface WorkInfoBasic {
  personID: number;
  orderID: number;
  costCenterID: number;
  operation: string | undefined;
  absenceID: number;
}

export interface WorkInfoCostCenter {
  time: string | undefined;
  costCenter: CostCenterListItem;
  selectable: boolean;
  shouldBeSelectedNext: boolean;
}

export interface WorkInfoOnAbsenceChange {
  absenceID: number;
  personID: number;
  oldState: WorkInfo;
}

export interface WorkInfoOnCostCenterChange {
  newCostCenterID: number;
  personID: number;
  oldState: WorkInfo;
}

export interface WorkInfoOnOperationChange {
  newOperationAksID: number;
  operationText: string | undefined;
  orderID: number;
  personID: number;
  oldState: WorkInfo;
}

export interface WorkInfoOnOrderChange {
  newOrderID: number;
  personID: number;
  oldState: WorkInfo;
}

export interface WorkInfoOperation {
  time: string | undefined;
  operation: OperationListItem;
  text: string | undefined;
  state: OperationStateEnum;
  visible: boolean;
  shouldBeSelectedNext: boolean;
}

export interface WorkInfoOrder {
  order: OrderListItem;
  selectable: boolean;
  time: string | undefined;
  shouldBeSelectedNext: boolean;
}

export interface WorkflowActionResult {
  errorType: WorkflowVisumErrorEnum;
  person: PersonalApiModel;
  visumDate: string;
  actionDate: string;
  message: string | undefined;
  detail: string | undefined;
}

export interface WorkflowActionResultListTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: WorkflowActionResult[] | undefined;
}

export enum WorkflowEmailErrorEnum {
  NoError = 0,
  NoEmail = 1,
  AlreadyFullySigned = 2,
  SignNotMandatory = 3,
  EMailServerError = 4,
}

export interface WorkflowEmailResult {
  emailErrorType: WorkflowEmailErrorEnum;
  person: PersonalApiModel;
  user: UserModel;
  actionDate: string;
  message: string | undefined;
}

export interface WorkflowEmailResultListTaskResultGeneric {
  successful: boolean;
  message: string | undefined;
  resultObject: WorkflowEmailResult[] | undefined;
}

export interface WorkflowSetVisumParameters {
  items: WorkFlowModel[] | undefined;
  visumDate: string;
}

export enum WorkflowVisumErrorEnum {
  NoError = 0,
  KGError = 1,
  SaldoError = 2,
  SetVisumError = 3,
}

export interface ZeitenRecalcParamter {
  personID: number;
  datumVon: string;
  datumBis: string;
  updateSaldo: boolean;
  userNameZeitenMod: string | undefined;
  wartungsLauf: boolean;
  newPerson: boolean;
}

export interface FileParameter {
  data: any;
  fileName: string;
}
